import { useHistory, useLocation } from "react-router-dom";

/*
  This is to help when needing to close a modal that is URL-driven. It removes the pathString that gets passed in, and also the
  trailing ID (if removeTrailingID is set to true).

  This also properly handles if url is (for instance):
  /everyone/people/user/1234/merge/5678 -or- /everyone/people/merge/5678/user/1234

  Usage Example:

  const closeModal = useCloseModal({
    pathString: "merge",
    removeTrailingID: true,
  });

  const handleCloseClick = () => {
    closeModal();
  };

*/

export function useCloseModal({ pathString, removeTrailingID }) {
  const history = useHistory();
  const location = useLocation();

  return function () {
    const path = location.pathname.split("/");
    const pathStringIndex = path.findIndex((x) => x === pathString);

    delete path[pathStringIndex]; // removes the pathString
    if (removeTrailingID) {
      delete path[pathStringIndex + 1]; // removes the trailingID
    }

    const newPathname = path.filter((x) => x).join("/") + location.search;

    history.push(`/${newPathname}`);
    if (window.fnReactBus?.goToUrl) {
      window.fnReactBus.goToUrl(newPathname);
    }
  };
}
